"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var attach_money_svg_1 = __importDefault(require("../../../assets/icons/formatacao/attach_money.svg"));
var backspace_svg_1 = __importDefault(require("../../../assets/icons/formatacao/backspace.svg"));
var crop_svg_1 = __importDefault(require("../../../assets/icons/formatacao/crop.svg"));
var format_align_center_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_align_center.svg"));
var format_align_justify_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_align_justify.svg"));
var format_align_left_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_align_left.svg"));
var format_align_right_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_align_right.svg"));
var format_bold_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_bold.svg"));
var format_italic_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_italic.svg"));
var format_list_bulleted_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_list_bulleted.svg"));
var format_underlined_svg_1 = __importDefault(require("../../../assets/icons/formatacao/format_underlined.svg"));
var numbers_svg_1 = __importDefault(require("../../../assets/icons/formatacao/numbers.svg"));
var percent_svg_1 = __importDefault(require("../../../assets/icons/formatacao/percent.svg"));
var reais_svg_1 = __importDefault(require("../../../assets/icons/formatacao/reais.svg"));
var squared_meter_svg_1 = __importDefault(require("../../../assets/icons/formatacao/squared_meter.svg"));
var Formatacao = {
    attach_money: attach_money_svg_1.default,
    backspace: backspace_svg_1.default,
    crop: crop_svg_1.default,
    format_align_center: format_align_center_svg_1.default,
    format_align_justify: format_align_justify_svg_1.default,
    format_align_left: format_align_left_svg_1.default,
    format_align_right: format_align_right_svg_1.default,
    format_bold: format_bold_svg_1.default,
    format_italic: format_italic_svg_1.default,
    format_list_bulleted: format_list_bulleted_svg_1.default,
    format_underlined: format_underlined_svg_1.default,
    numbers: numbers_svg_1.default,
    percent: percent_svg_1.default,
    reais: reais_svg_1.default,
    squared_meter: squared_meter_svg_1.default
};
exports.default = Formatacao;
